<ng-template let-row="row" let-value="value">
    <div class="d-flex align-items-center">
        <div class="logo mr-10px">
            <img *ngIf="value.imageUrl" class="logo-img w-100 h-100" src="{{value.imageUrl}}" alt="Partner Logo">
        </div>
        <span>{{value.textValue}}</span>
    </div>
</ng-template>
